import { ConfigConstants } from '../../config/config-constants';
import { JsonModelOptions, ModelOptions } from './model-options';

/**
 * Configure the behaviour of a NumberModel
 */
export class NumberModelOptions extends ModelOptions {
    public readonly minValue: number;
    public readonly maxValue: number;
    public readonly minLength: number;
    public readonly maxLength: number;
    public readonly placeholder: string;
    public readonly pattern: string;
    public readonly patternScan: string;
    public readonly required: boolean;
    public readonly scannable: boolean;
    public readonly readonly: boolean;
    public readonly step: number;
    public readonly unit: string;
    public readonly allowReadonlyValidation: boolean;

    public constructor({
        minValue = -Infinity,
        maxValue = Infinity,
        minLength = 0,
        maxLength = Infinity,
        placeholder = '',
        pattern = ConfigConstants.validationBackupPattern.Decimal,
        patternScan = ConfigConstants.validationBackupPattern.Decimal,
        required = false,
        scannable = false,
        readonly = false,
        step = 1,
        unit = '',
        allowReadonlyValidation = false,
    } = {}) {
        super();
        this.minValue = minValue;
        this.maxValue = maxValue;
        this.minLength = minLength;
        this.maxLength = maxLength;
        this.placeholder = placeholder;
        this.pattern = pattern;
        this.patternScan = patternScan;
        this.required = required;
        this.scannable = scannable;
        this.readonly = readonly;
        this.step = step;
        this.unit = unit;
        this.allowReadonlyValidation = allowReadonlyValidation;
    }
}

export class NumberModelOptionsFromJson extends NumberModelOptions {
    public constructor(data: JsonNumberModelOptions) {
        super({
            minValue: data.minValue ? data.minValue : -Infinity,
            maxValue: data.maxValue ? data.maxValue : Infinity,
            minLength: data.minLength ? data.minLength : 0,
            maxLength: data.maxLength ? data.maxLength : Infinity,
            placeholder: data.placeholder,
            pattern: data.pattern,
            patternScan: data.patternScan,
            required: data.required,
            scannable: data.scannable,
            readonly: data.readonly,
            step: data.step,
            unit: data.unit,
            allowReadonlyValidation: data.allowReadonlyValidation,
        });
    }
}

export interface JsonNumberModelOptions extends JsonModelOptions {
    minValue: number;
    maxValue: number;
    minLength: number;
    maxLength: number;
    placeholder: string;
    pattern: string;
    patternScan: string;
    required: boolean;
    scannable: boolean;
    readonly: boolean;
    step: number;
    unit: string;
    allowReadonlyValidation: boolean;
}
